<template>
  <div>
    <el-image style="" v-for="url in urls" :key="url" :src="url"></el-image>
  </div>
</template>

<script>

  export default {
		name: "dcbg",
		data() {
			return {
				loading:false,
        urls:[]
			}
		},
		created() {
			this.getJson()
		},
		methods: {
      getJson(){
        let url = window.location.href;
        this.loading = true;
        let sysKey = url.split('?')[1];
        this.$axios.get("/weChat/getImg",{
              params: {
                url: "http://10.10.0.189:86/WebPacsView/OTHER/pacs.php?imgAnno=show&action=LoadStudy&studyuid="+sysKey
              }
          }).then(res => {
            this.urls = res.data.result
            console.log(this.urls)
        })
      }
		}
	}
</script>